import { Component, OnInit } from '@angular/core';
import * as firebase from 'firebase';


const settings = {
    ssl: true,
    timestampsInSnapshots: true
};


const config = {
    apiKey: 'AIzaSyBY8yQgLorEeVFpxRsa6ZZBhYbOEP0g48U',
    authDomain: 'cvcf-attendees.firebaseapp.com',
    databaseURL: 'https://cvcf-attendees.firebaseio.com',
    projectId: 'cvcf-attendees',
    storageBucket: 'cvcf-attendees.appspot.com',
    messagingSenderId: '857747935055',
};

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

    titleOne = 'CVCF Youth Retreat 2026 Registration Form';
    titleTwo = 'When: Thursday July 30th - August 2nd ';
    themeVerse = 'Theme : Who Are You';
    themeVerseReference ='"And we all, with unveiled face, beholding the glory of the Lord, are being transformed into the same image from one degree of glory to another. For this comes from the Lord who is the Spirit"';
    themeverselocation = "2 Corinthians 3:18"

    page = 'attendeesFormPage';

    constructor() {

    }

    ngOnInit() {
        firebase.default.initializeApp(config);
        firebase.default.firestore().settings(settings);

    }

    switchPage(page) {
        this.page = page;
    }
}
